import './StickyElement.scss';

import offset from 'dom-helpers/offset';
import React, { Component, createRef, RefObject } from 'react';
// import {width} from "dom-helpers";

export default class StickyElement extends Component<
  {},
  { isSticky: boolean; top: number; width: number }
> {
  state = {
    isSticky: false,
    top: 0,
    width: 0,
  };

  private ref: RefObject<HTMLDivElement> = createRef();
  parent: Window;

  componentDidMount(): void {
    this.parent = window;
    if (!this.parent) {
      return;
    }
    this.parent.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount(): void {
    if (!this.parent) {
      return;
    }
    // this.parent.removeEventListener('scroll', this.handleScroll);
    // if (this.ref.current) {
    //   this.setState({width: width(this.ref.current)})
    // }
  }

  private handleScroll = _ => {
    if (!this.ref.current) {
      return;
    }

    const childTop = offset(this.ref.current).top;
    if (childTop < -0.5) {
      if (!this.state.isSticky) {
        this.setState({ isSticky: true });
      }
    } else if (childTop > -0.5 && this.state.isSticky) {
      this.setState({ isSticky: false });
    }
  };

  render() {
    const { children } = this.props;
    return (
      <div ref={this.ref} className="sticky">
        <div className={this.state.isSticky ? 'sticky--pin' : 'sticky--upin'}>
          {children}
        </div>
      </div>
    );
  }
}
